<template>
  <div class="SpecialPage">
    <LoadingContent v-if="isLoading" class="loadingContent" />
    <template v-else-if="view_type === 'detail'">
      <SpecialPageDetail
          @catchTitle="setTitle"
      />
    </template>

    <div v-else>
      <template v-if="!CMS_response">
        <template v-if="error">
          <p class="cms__error">{{ error }}</p>
        </template>
      </template>

      <template v-if="CMS_response">
        <template v-if="view_type === 'carousel'">
          <SpecialPageCarousel
            :cmsResponse="CMS_response"
            :viewArea="view_area"
            :specialCategory="special_category"
            :showMore="show_more"
          />
        </template>

        <template v-else-if="view_type === 'column'">
          <SpecialPageColumn
            :cms_response="CMS_response"
            :view_area="view_area"
            :special_category="special_category"
          />
        </template>
      </template>
    </div>
  </div>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import SpecialPageCarousel from "@/general/components/cms/view_type/SpecialPageCarousel.vue";
import SpecialPageColumn from "@/general/components/cms/view_type/SpecialPageColumn.vue"
import SpecialPageDetail from "@/general/components/cms/view_type/SpecialPageDetail.vue";

import TopPageApi from "@/general/api/topPageApi";

@Options({
  props: {
    view_type: { type: String, default: "" },
    page_limit: { type: String, default: "" },
    view_area: { type: String, default: "" },
    special_category: { type: String, default: null },
    show_more: { type: Boolean, default: true }
  },
  components: {
    SpecialPageColumn,
    SpecialPageDetail,
    SpecialPageCarousel
  }
})
export default class SpecialPage extends Vue {
  view_type!: string;
  page_limit!: string;
  view_area!: string;
  special_category!: string;
  show_more!: boolean;

  error: any = null;
  CMS_response = null;
  ApiResponse = {
    data: {},
    isError: false
  };
  isLoading = true;

  async created() {
    if(this.view_type === 'detail') {
      this.isLoading = false;
      return;
    } else {
      await this.readcms();
    }
    this.isLoading = false;
  }

  async readcms() {
    const APIres = await TopPageApi.getSpecialPage({
      page_limit: this.page_limit,
      view_area: this.view_area,
      contract_id: null,
      course_id: null
    });
    this.ApiResponse.data = APIres;
    this.ApiResponse.isError = APIres?.isError;

    if (this.ApiResponse.isError) {
      this.error = "コンテンツの読み込みに失敗しました";
    } else {
      return this.setResponse(this.ApiResponse);
    }
  }

  setResponse(obj: any) {
    if (
      !obj ||
      !obj.data ||
      !obj.data.data ||
      !obj.data.included ||
      !obj.data.included[0]
    ) {
      return;
    }
    this.CMS_response = obj.data;
  }

  setTitle(title: string) {
    this.$emit("catchTitle", title);
  }
}
</script>
<style scoped>
.loadingContent {
  padding-top: 1rem;
}
</style>
